import { Component, ViewChild, ElementRef } from '@angular/core';
import { generalService } from '../../services/general.service';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { MatPaginator, MatSort } from '@angular/material';
import { DatosGeneralesSAE } from '../../datos-generales-SAE';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
import { utils } from '../../utils/utils';
import { DataService } from '../../utils/data.service';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Component({
  selector: 'inventarioAlmacen-component',
  templateUrl: './inventario-almacen.component.html',
  styleUrls: [],
  providers: [generalService]
})
export class inventarioAlmacenComponent {
  constructor(private _generalService: generalService, 
                public dataService: DataService,
  ) 
  {
    this.dataInventario = new Array();
    this.datosGeneralesSAE = DatosGeneralesSAE;
    this.datosGeneralesSAE.showSpinnerLoading = false;
    this.fechaActual = new Date();
  }
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('tableInventario') tableInventario: ElementRef;
  public dataSource: DataSourceGrid | null;
  public displayedColumns = ['acciones', 'almacen', 'familia', 'subfamilia', 'producto', 'contenedor', 'unidad', 'precioCompra', 'minimo', 'comentario'];
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public idSucursal:number = this.userData.ORGANIZATION_ID;
  public sucursal: string = this.userData.ORGANIZATION_NAME;
  public fechaActual: Date;
  public almacenes = [];
  public dataInventario: Array<any>;
  public numberOfRecords = 0;
  public datosGeneralesSAE: any;
  public palabraFiltro2 = null;


  ngOnInit() {
    this.almacenesGetList();
    this.inventarioGetTable(0);
  }

  almacenesGetList(): Promise<void> {
    return new Promise((resolve, reject) => {
      this._generalService
        .metodoCallParams(this.idSucursal, 'EntradaAlmacen/almacenesGetList')
          .subscribe(result => {
            result = JSON.parse(result);
            this.almacenes = result;
            resolve();
          }, error => {
            reject();
          });
    });
  }

  inventarioGetTable(selectedAlmacen) {
    let webService = 'InventarioAlmacen/inventarioGetTable?idSucursal=' + this.idSucursal + '&&idAlmacen=' + selectedAlmacen;
    this._generalService
      .metodoCall(webService, true)
      .subscribe(result => {
        this.dataInventario = result;
        this.dataSource = new DataSourceGrid(this.dataInventario, this.paginator, this.sort);
        this.numberOfRecords = this.dataInventario.length;
        if(this.dataInventario.length <= 0)
          { $(".mat-row").remove(".mat-row"); }
        },
      error => {  console.log(<any>error);  }
    );
  }

  public exportarExcel(): void {
    let filename = 'Existencias de Almacenes de ' + this.sucursal;
    this.datosGeneralesSAE.showSpinnerLoading = true;
    const worksheet: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.tableInventario.nativeElement);

    const headers = ['Inventario:', 'Fecha:', 'Almacén', 'Familia', 'SubFamilia', 'Producto', 'Contenedores', 'Piezas', 'Precio Compra', 'Mínimo', 'Comentario'];
        for (const z in worksheet) {
            if (z[0] === '!') { 
                continue; 
            }
            if (worksheet[z]) {
                if (headers.indexOf(worksheet[z].v + '') > -1) {
                    this.wrapAndCenterCell(worksheet[z], 'header');
                }
            }
        }
    const workbook: XLSX.WorkBook = { Sheets:{Inventario: worksheet}, SheetNames: ['Inventario'] };
    const excelBuffer: any = XLSXStyle.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, filename);
}

  private wrapAndCenterCell(cell: XLSX.CellObject, tipo: any) {
    let cellStyle;
    switch (tipo) {
      case 'header': {
        cellStyle = { font: {bold: true} };
        break;  }
    }
    this.setCellStyle(cell, cellStyle);
  }

  private setCellStyle(cell: XLSX.CellObject, style: {}) {
    cell.s = style;
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    this.datosGeneralesSAE.showSpinnerLoading = false;
  }

  searchFilter(searchTerm2: string) {
        this.dataService.palabraFiltro2 = searchTerm2;
        if(this.dataInventario.length <= 0) {
          this.dataSource = undefined;  } 
        else {
          let filteredProducts = this.dataInventario;
          if(searchTerm2 != "") {
            filteredProducts = this.dataInventario.slice().filter(item => {   
              const term2 = searchTerm2.toLowerCase();         
              if (item.producto.toLowerCase().includes(term2) ||
                  item.subfamilia.toLowerCase().includes(term2))
                return true;
              else
                return false;
            });
          }
          
          this.dataSource = new DataSourceGrid(filteredProducts, this.paginator, this.sort);
          this.numberOfRecords = filteredProducts.length;
        }
    }

/*
searchFilter(searchTerm: string) {
  if(this.clientes.length <= 0) {
    this.dataSource = undefined;
  } else {
    let filtroClientes = this.clientes;
    if(searchTerm != "") {
      filtroClientes = this.clientes.filter((obj: any) => {            
        if (obj.razonSocial.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 || 
            obj.rfc && obj.rfc.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1 )
            return true;
        else
            return false;
      });
    }
    this.dataSource = new DataSourceGrid(filtroClientes, this.paginator, this.sort);
  }
}*/


}



// WEBPACK FOOTER //
// ./src/app/almacen/inventario/inventario-almacen.component.ts